export default {
  common: {
    MOP: 'Pide y Retira',
  },
  alertDialog: {
    mcDeliveryError: {
      body: 'Mientras tanto, puedes hacer un pedido y retirarlo en el restaurante más cercano con @:common.MOP',
    },
  },
}
